import request from "@/utils/request";

export function getCouponActivitys(data) {
  return request({
    url: "/marketing/coupon/activity/list",
    method: "get",
    params: data,
  });
}

export function addCouponActivity(data) {
  return request({
    url: "/marketing/coupon/couponActivitys",
    method: "post",
    data,
  });
}

export function submitCouponActivity(id) {
  return request({
    url: "/marketing/coupon/couponActivitys/submit/" + id,
    method: "post",
  });
}

export function getCouponActivityDetail(id) {
  return request({
    url: "/marketing/coupon/couponActivitys/" + id,
    method: "get",
  });
}

// 活动详情
export function activityInfo(id) {
  return request({
    url: `/marketing/coupon/activity/info/${id}`,
    method: "get",
  });
}

// 新增活动
export function addActivityInfo(data) {
  return request({
    url: `/marketing/coupon/activity/add`,
    method: "POST",
    data,
  });
}

// 新增活动
export function editActivityInfo(data) {
  return request({
    url: `/marketing/coupon/activity/edit`,
    method: "put",
    data,
  });
}

// 删除活动
export function deleteActivityInfo(id) {
  return request({
    url: `/marketing/coupon/activity/delete/${id}`,
    method: "DELETE",
  });
}

// 停止活动
export function stopActivityInfo(id) {
  return request({
    url: `/marketing/coupon/activity/stop/${id}`,
    method: "PUT",
  });
}

// 作废活动
export function disableActivityInfo(id) {
  return request({
    url: `/marketing/coupon/activity/disable/${id}`,
    method: "PUT",
  });
}
// 模糊搜索商户
export function fuzzySearchMerchant(data) {
  return request({
    url: "/shop/shop/searchByName",
    method: "get",
    params: data,
  });
}
// 对指定店铺发送优惠券
export function sendCouponToShop(data) {
  return request({
    url: "/marketing/coupon/coupon/couponSend",
    method: "post",
    data,
  });
}
// 查询已发放店铺优惠券列表
export function getSendCouponList(data) {
  return request({
    url: "/marketing/coupon/coupon/couponUseList",
    method: "get",
    params: data,
  });
}
// 查询活动下的已领取的优惠券列表
export function getCouponListWithClaimed(data) {
  return request({
    url: `/marketing/coupon/coupon/couponUsePage`,
    method: "get",
    params: data,
  });
}
// 撤回已发放的优惠券
export function rollBackCoupon(data) {
  return request({
    url: `/marketing/coupon/coupon/rollBack`,
    method: "post",
    data,
  });
}
